/**
 * What Terminal is, in nine tiles.
 *
 * Operator, 2026-09-07: *literally in slogans — Terminal, Wallet, Assistant,
 * LLM models, Skills, Bots, Router, Marketplace, Channels — with one sentence
 * each, very short.*
 *
 * A sentence each and no more. This page is read by somebody deciding whether
 * to download an application, not by somebody using one: a paragraph here is a
 * paragraph they skip, and the tile stops saying anything at all.
 *
 * The order is the order a holder meets them — the thing itself, then their
 * money, then what helps, then what runs, then where it trades, then where it
 * comes from, then who they talk to.
 */
export interface Feature {
  name: string
  line: string
}

export const FEATURES: Feature[] = [
  {
    name: 'Terminal',
    line: 'A prompt on your own machine. Describe a strategy in your own words and watch it be written, tested and run.'
  },
  {
    name: 'Wallet',
    line: 'One recovery phrase, many wallets derived from it. The keys are yours and never leave the machine.'
  },
  {
    name: 'Assistant',
    line: 'Reads and explains — your licence, your bots, your money. It answers; it never acts.'
  },
  {
    name: 'LLM models',
    line: 'Downloaded and run locally, verified by digest. Nothing you type is sent anywhere.'
  },
  {
    name: 'Skills',
    line: 'The commands the terminal already knows, each declaring what it touches and what it refuses.'
  },
  {
    name: 'Bots',
    line: 'Strategies that run on your machine, from your own wallets, and stop when you say so.'
  },
  {
    name: 'Router',
    line: 'Every trade goes through the MPRO Lab swap router on Base — on chain, and visible like any other swap.'
  },
  {
    name: 'Marketplace',
    line: 'Buy a bot for MPRO, or post what you want built. Publish your own and take a fee on every trade it makes.'
  },
  {
    name: 'Channels',
    line: 'The community, your clan, and a channel for each of your bots to tell you what it did.'
  }
]
